module.exports = __webpack_public_path__ + "img/bb_g1_t_nose-03.e640c483.svg";